// extracted by mini-css-extract-plugin
export var errorsContainer = "_sg-1";
export var link = "_sg-0";